import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { KindergartenDayOffWrite } from '@isophi/mng-api';

import { RouterLinkFactory } from '../../../../core/router/router-link.factory';
import { HelperService } from '../../../../core/services/helper.service';
import { kindergartenDayOffReadDayOffTypeData } from './data';

@Component({
  selector: 'app-holidays-dates-form',
  templateUrl: './holidays-dates-form.component.html',
  styleUrls: ['./holidays-dates-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HolidaysDatesFormComponent {
  @Input() submitButtonText: string;

  @Output() formSubmit: EventEmitter<any> = new EventEmitter<any>();

  holidaysDatesForm: FormGroup;

  initialValues;

  kindergartenDayOffReadDayOffType: { [key: string]: string }[] = [];

  constructor(private helperService: HelperService, private formBuilder: FormBuilder, public links: RouterLinkFactory) {
    this.kindergartenDayOffReadDayOffType = kindergartenDayOffReadDayOffTypeData;
    this.holidaysDatesForm = this.formBuilder.group({
      dayOffType: [null, Validators.required],
      date: [null, Validators.required],
      dateTo: [null],
      name: ['', Validators.required],
    });

    this.initialValues = { ...this.holidaysDatesForm.value };
  }

  onSubmit(): void {
    if (this.holidaysDatesForm.valid) {
      const data = this.prepareFormData(this.holidaysDatesForm.value);

      this.formSubmit.emit(data);
    }
  }

  private prepareFormData(formData): KindergartenDayOffWrite {
    return {
      dayOffType: formData.dayOffType,
      name: formData.name,
      date: this.helperService.formateDate(formData.date),
      ...(formData.dateTo && { dateTo: this.helperService.formateDate(formData.dateTo) }),
    };
  }

  setFormData(data): void {
    data.date = this.helperService.parseDate(data.date);
    data.dateTo = this.helperService.parseDate(data.dateTo);

    this.holidaysDatesForm.patchValue(data);
  }

  resetGroupForm(): void {
    this.holidaysDatesForm.reset(this.initialValues);
  }
}
